import { Box, Button, Divider, Label, Typography } from "@bca/ui-library";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import { formatMoney } from "../formatMoney";
import { useViewport, Devices } from "../Hooks/useViewport.hook";
import { Vehicle } from "../Interfaces/vehicle.type";
import { vatStatusMapper } from "../Mappers/vehicleDetailsMappers";
import { REMOVE_VEHICLE } from "../redux/slices/bookDeliverySlice";
import selectForMultipleDeliveryDataPush from "../AdobeDataPushes/vehicleCard/selectForMultipleDeliveryDataPush";

interface SelectedVehicleRowProps {
  vehicle: Vehicle;
}

const RemoveButton = styled(Button)`
  text-decoration: none;
`;

const VehicleDivider = styled(Divider)`
  background: secondary-light-grey;
`;

const VehicleRow = styled(Box)`
  &:last-child {
    margin-bottom: 0px;
  }
`;

const SelectedVehicleRow: React.FunctionComponent<SelectedVehicleRowProps> = ({
  vehicle,
}) => {
  const device = useViewport();
  const dispatch = useDispatch();

  const handleRemoveVehicle = () => {
    selectForMultipleDeliveryDataPush(vehicle, "button", "remove", "footer");
    dispatch(
      REMOVE_VEHICLE({
        vrm: vehicle.vrm,
      })
    );
  };

  const isMobile = device === Devices.MOBILE;

  return (
    <VehicleRow display="flex" flexDirection="column" marginBottom={5}>
      <Box
        display="flex"
        alignItems="center"
        marginBottom={1}
        justifyContent="space-between"
      >
        <Label
          label={vehicle.vrm}
          backgroundColor="secondary-light-grey"
          textColor="grey-blue"
          fontWeight="bold"
          leftEdgeColor="primary-light-blue"
        />
        <RemoveButton
          variant="tertiary"
          icon="trash"
          iconHeight={18}
          iconWidth={16}
          iconAlignment={isMobile ? "right" : "left"}
          height={18}
          fontSize="body-small"
          padding={0}
          onClick={handleRemoveVehicle}
        >
          {isMobile ? "" : "Remove"}
        </RemoveButton>
      </Box>
      <Typography variant="h5" color="footer-blue" margin={0} marginBottom={1}>
        {vehicle.primaryVehicleDescription}
      </Typography>
      <Box display="flex" alignItems="center" marginBottom={1}>
        <Typography
          variant="h6"
          color="footer-blue"
          htmlTag="p"
          marginTop={0}
          marginBottom={0}
          marginRight={1}
        >
          {formatMoney(vehicle.bidAmount)}
        </Typography>
        <Typography
          variant="label"
          color="grey-blue"
          htmlTag="p"
          margin={0}
          fontWeight="normal"
        >
          {vatStatusMapper[vehicle.vatType]}
        </Typography>
      </Box>
      <Box display="flex" height="10px" justifyContent="center">
        <VehicleDivider orientation="horizontal" width="100%" />
      </Box>
    </VehicleRow>
  );
};

export default SelectedVehicleRow;
